import { ApiService } from '../../../types/api';
import type { ApiHandlerContract } from '../../../types/handlers/api';
import type { CustomerLookup } from '../types/api';
import type { CustomerAddress } from '../types/customer';
import { CustomerAddressApi, type CustomerAddressApiContract } from './address.api';

/**
 * A service contract to interact with a specific customer's addresses via the SparkLayer API.
 */
export interface CustomerAddressesApiContract {
  list(): Promise<CustomerAddress[]>;
  create(payload: CustomerAddress): Promise<CustomerAddress>;
  address(addressId: string): CustomerAddressApiContract;
}

export class CustomerAddressesApi extends ApiService implements CustomerAddressesApiContract {
  constructor(
    api: ApiHandlerContract,
    private customerLookup: CustomerLookup,
  ) {
    super(api);
  }

  public list(): Promise<CustomerAddress[]> {
    return this.api.proxy({
      method: 'GET',
      path: `/v2/customers/{lookupBy}/{identifier}/addresses`,
      params: {
        lookupBy: this.customerLookup.by,
        identifier: this.customerLookup.identifier,
      },
    });
  }

  public create(payload: CustomerAddress): Promise<CustomerAddress> {
    return this.api.proxy({
      method: 'POST',
      path: `/v2/customers/{lookupBy}/{identifier}/{addressId}`,
      payload,
      params: {
        lookupBy: this.customerLookup.by,
        identifier: this.customerLookup.identifier,
        // TODO: Generate ID or wait for decision on backend ID generation
        addressId: payload.id ?? '',
      },
    });
  }

  public address(addressId: string): CustomerAddressApiContract {
    return new CustomerAddressApi(this.api, this.customerLookup, addressId);
  }
}
